export default __webpack_public_path__ + "static/night_ctaModule_table_tablet-b2a74c6773bdf43d03d5055cecc3e1f7.png";